<script>
  import Container from '@/Elements/Containers/FullCentred.svelte';
  import Meta from '@/Elements/Signals/Dark/Meta/XSmall.svelte';
  import Title from '@/Elements/Signals/Dark/Title.svelte';
  import Lead from '@/Elements/Signals/Dark/Text/Base.svelte';
  import Text from '@/Elements/Signals/Dark/Text/Small.svelte';
  import Subtext from '@/Elements/Signals/Dark/Text/XSmall.svelte';

  export let connect;

  let meta = connect.meta;
  let title = connect.title;
  let content = connect.content;
  let contact = connect.content.contact;

</script>

<style></style>

<section id="contact-us" class="py-36 bg-gray-50">
  <Container>
    <div class="flex flex-col lg:flex-row">
      <div class="px-var py-6 space-y-12 lg:w-3/5">
        <div class="space-y-3">
          <div class="space-y-1">
            <Meta>{meta}</Meta>
            <Title>{title}</Title>
          </div>
          <Lead>{content.lead}</Lead>
        </div>
        <div class="text-gray-900 opacity-95 space-y-2">
          {#each contact as option}
          <div class="flex space-x-2">
            <div class="w-6 h-6">
              <span>{@html option.icon}</span>
            </div>
            <p>{option.value}</p>
          </div>
          {/each}
        </div>
        <div class="space-y-3">
          <div>
            <Text>{content.legal.name}</Text>
            <Subtext>Reg No. {content.legal.vat}</Subtext>
          </div>
          <div>
            <Text>{content.legal.coop}</Text>
            <Subtext>Reg No. {content.legal.coopReg}</Subtext>
          </div>
        </div>
      </div>
      <div class="pipedriveWebForms" data-pd-webforms="https://webforms.pipedrive.com/f/1r5BL4d1FCNfaWfTpqUgqYp4A5qWzsVG6gkdZWPmSwgkd1wr2IdSnUvgxVL5qhmCL"></div>
    </div>
  </Container>
</section>